import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class CallService {
 
async getCallPermissionState(contactId, phoneNumber) {
    const params = new URLSearchParams();
    if (contactId) params.append('contact_id', contactId);
    if (phoneNumber) params.append('phone_number', phoneNumber);
    
    const response = await request.get(
      `/call/permission/${appConfig.getServiceId()}?${params.toString()}`
    );
    return response?.data ?? response;
  }

  async sendPermissionRequest(contactId, phoneNumber, customBody = null) {
    const response = await request.post(
      `/call/permission-request/${appConfig.getServiceId()}`,
      { contact_id: contactId, phone_number: phoneNumber, custom_body: customBody }
    );
    return response.data;
  }

async initiateCall(serviceId, contactId, phoneNumber, sdpOffer) {
        const response = await request.post(`/call/initiate/${serviceId}`, {
            contact_id: contactId,
            phone_number: phoneNumber,
            sdp_offer: sdpOffer
        });
        return response.data;
    }

async terminateCall(serviceId, callId) {
        const response = await request.post(`/call/terminate/${serviceId}`, {
            call_id: callId
        });
        return response.data;
    }

async getSdpAnswer(serviceId, contactId) {
        const response = await request.get(`/call/sdp-answer/${serviceId}`, {
            params: { contact_id: contactId }
        });
        return response.data;
    }

async getCallHistory(serviceId, contactId, limit = 50) {
        const response = await request.get(`/call/history/${serviceId}`, {
            params: { 
                contact_id: contactId,
                limit: limit 
            }
        });
        return response.data;
    }
async getCallStatus(serviceId, callId) {
        const response = await request.get(`/call/status/${serviceId}`, {
            params: { call_id: callId }
        });
        return response.data;
    }

//   USER-INITIATED CALL 
async getIncomingCalls(serviceId, limit = 10) {
  const response = await request.get(`/call/incoming/${serviceId}?limit=${limit}`);
  return response.data;
}

async preAcceptCall(phoneNumberId, callId, sdpAnswer) {
  const response = await request.post(`/call/pre-accept/${phoneNumberId}`, {
    call_id: callId,
    sdp_answer: sdpAnswer
  });
  return response.data;
}

async acceptCall(phoneNumberId, callId, sdpAnswer) {
  const response = await request.post(`/call/accept/${phoneNumberId}`, {
    call_id: callId,
    sdp_answer: sdpAnswer
  });
  return response.data;
}

async rejectCall(phoneNumberId, callId) {
  const response = await request.post(`/call/reject/${phoneNumberId}`, {
    call_id: callId
  });
  return response.data;
}

async getMissedCalls(serviceId, contactId = null, limit = 10) {
  let url = `/call/missed/${serviceId}?limit=${limit}`;
  if (contactId) {
    url += `&contact_id=${contactId}`;
  }
  const response = await request.get(url);
  return response.data;
}

async getUnreadMissedCalls(serviceId, contactId = null, limit = 50) {
  let url = `/call/missed/${serviceId}?unread_only=true&limit=${limit}`;
  if (contactId) {
    url += `&contact_id=${contactId}`;
  }
  const response = await request.get(url);
  return response.data;
}

async markMissedCallsAsRead(serviceId, contactId = null) {
  let url = `/call/missed/${serviceId}/read`;
  if (contactId) {
    url += `?contact_id=${contactId}`;
  }
  const response = await request.post(url);
  return response.data;
}

async getServiceCallLogs(serviceId, filter = 'all', limit = 50) {
  const response = await request.get(`/call/logs/${serviceId}`, {
    params: { filter, limit },
  });
  return response.data;
}
  
}

export default new CallService();